import styled, { css } from 'styled-components';
import { ScBanksLogosListWrapper } from '@/modules/promo/components/BanksLogosList/styled';
import { device } from '@/styles/helpers';
import { ScButton } from '../../components/buttons/styled';
import { ScTermsAndConditions } from '../BenefitsTemplate/components/Terms&Conds/styled';

export const ScWithoutBenefitsTemplate = styled.div<{
  bgImage: string;
  bgMobImg?: string;
  copyActive?: boolean;
  buttonHeight?: { xxLarge?: boolean; xLarge?: boolean };
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: url(${({ bgImage }) => bgImage}) top center / cover no-repeat;
  background-attachment: fixed;
  padding: 32px 0 28px;
  position: relative;
  min-height: 100vh;
  min-height: 100dvh;
  @media (${device.mobile}) {
    padding-block: 16px;
    justify-content: flex-start;
  }
  @media (max-width: 640px) {
    background-size: 640px 360px;
    background-attachment: scroll;

    ${({ bgMobImg }) =>
      bgMobImg &&
      css`
        background-image: url(${bgMobImg});
      `}
  }

  & img {
    display: block;
    max-width: 100%;
  }

  & > .left-decor-img {
    position: absolute;
    left: 0;
    top: 10%;
    max-width: 200px;
    @media (${device.mobile}) {
      display: none;
    }
  }

  & .container {
    width: min(1184px, 100%);
    padding: 0 16px;
    margin-inline: auto;
  }

  & .top-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-bottom: 32px;
    @media (${device.mobile}) {
      grid-template-columns: 1fr;
      margin-bottom: 16px;
    }

    & .mob-img {
      display: none;
      @media (${device.mobile}) {
        display: block;
        margin-top: 16px;
      }
    }

    & .code-wrapper {
      height: 40px;
      margin: 0;
      & p {
        padding-block: 4px;
        border: 2px dotted ${({ theme }) => theme.sunshineYellow};
        @media (${device.mobile}) {
          font-size: 20px;
        }
      }

      & button {
        height: 40px;
      }
    }

    & .left-column {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      & .terms-content ol {
        text-align: justify;
      }

      & .bonus {
        margin: 32px 0;
        color: #f0c018;
        text-transform: uppercase;
        font-weight: 700;
        text-align: center;
        position: relative;
        z-index: 2;
        @media (${device.mobile}) {
          margin: 16px 0 16px;
        }

        & .title {
          font-size: 22px;
          line-height: 28px;
          letter-spacing: 0.44px;
          @media (${device.mobile}) {
            font-size: 20px;
            line-height: 26px;
          }
        }

        & .fs-count {
          font-size: 200px;
          line-height: 100%;
          letter-spacing: 6px;
          margin: -16px 0;
        }

        & .medium-count {
          font-size: 128px;
          letter-spacing: 3.84px;
          margin-block: -4px;
          background: ${({ theme }) => theme.goldLightGradient};
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          @media (${device.mobile}) {
            font-size: 116px;
            letter-spacing: 3.48px;
          }
        }

        &:not(:has(> p.title)) .medium-count {
          font-size: 128px;
          line-height: 128px;
          letter-spacing: 3.84px;
          @media (${device.mobile}) {
            &.fr-CH,
            &.fr-CA {
              font-size: 112px;
            }
            font-size: 116px;
            line-height: 100%;
            letter-spacing: 2%;

            &.three-digit {
              font-size: 100px;
              letter-spacing: normal;
            }
          }
          @media (max-width: 374px) {
            &.fr-CH,
            &.fr-CA {
              font-size: 108px;
            }
            font-size: 111px;
            line-height: 100%;
            letter-spacing: 2%;
            &.three-digit {
              font-size: 100px;
              letter-spacing: normal;
            }
          }
        }

        & .fs {
          font-size: 40px;
          line-height: 100%;
          letter-spacing: 0.8px;
        }
      }

      ${ScTermsAndConditions} {
        padding: 16px 32px 0 32px;
        i {
          color: ${({ theme }) => theme.white};
        }
        @media (${device.mobile}) {
          padding: 8px 0 0 0;
        }
      }

      & .left-reg-button {
        display: flex;
        margin-top: 32px;
        width: 100%;
        max-width: ${({ buttonHeight }) =>
          buttonHeight?.xLarge ? '320px' : '360px'};
        height: ${({ buttonHeight }) =>
          buttonHeight?.xLarge ? '48px' : '56px'};
        .text {
          font-size: ${({ buttonHeight }) =>
            buttonHeight?.xLarge ? '22px' : '24px'};
          line-height: ${({ buttonHeight }) =>
            buttonHeight?.xLarge ? '28px' : ' 32px'};
          font-weight: 700;
          letter-spacing: ${({ buttonHeight }) =>
            buttonHeight?.xLarge ? '0.44px' : ' 0.24px'};
        }

        ${ScButton} {
          height: ${({ buttonHeight }) =>
            buttonHeight?.xLarge ? '48px' : '56px'};
        }

        .button {
          width: 100%;
          height: ${({ buttonHeight }) =>
            buttonHeight?.xLarge ? '48px' : '56px'};
        }

        @media (${device.mobile}) {
          max-width: none;
          margin-top: 16px;
          .text {
            font-size: ${({ buttonHeight }) =>
              buttonHeight?.xLarge ? '20px' : '22px'};
            line-height: ${({ buttonHeight }) =>
              buttonHeight?.xLarge ? '26px' : ' 28px'};
            font-weight: 700;
            letter-spacing: ${({ buttonHeight }) =>
              buttonHeight?.xLarge ? '0.4px' : ' 0.24px'};
          }
        }
      }
    }
  }

  & .right-column {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 44px;
    justify-content: center;

    .button {
      display: flex;
      width: 100%;
      justify-content: center;
    }

    .vibrating {
      animation: vibrate 0.2s infinite;
    }

    @keyframes vibrate {
      0% {
        transform: translateX(0);
      }
      25% {
        transform: translateX(-2px);
      }
      50% {
        transform: translateX(2px);
      }
      75% {
        transform: translateX(-2px);
      }
      100% {
        transform: translateX(0);
      }
    }

    & button {
      @media (${device.mobile}) {
        font-size: 20px;
        line-height: 26px;
        letter-spacing: 0.4px;
      }
    }

    & button {
      box-shadow: 0 0px 10px #58ce35;
    }
    & > img {
      @media (${device.mobile}) {
        display: none;
      }
    }
    & button,
    & a {
      width: min(320px, 100%);
      @media (${device.mobile}) {
        width: 100%;
      }
    }
  }

  .payments-wrapper {
    display: flex;
    width: 100%;
    justify-content: center;
    @media (${device.mobile}) {
      padding: 0 16px;
    }
    ${ScBanksLogosListWrapper} {
      display: flex;
      gap: 16px;
      justify-content: space-between;
      margin-top: 36px;
      width: 100%;
      max-width: 1248px;
      justify-content: center;
      @media (${device.mobile}) {
        gap: 12px;
        flex-wrap: wrap;
        margin-top: 16px;
        padding: 16px;
        border-radius: 12px;
        height: fit-content;
      }
    }
  }

  .mobile-reg-btn {
    display: none;

    @media (${device.mobile}) {
      display: block;
      width: 100%;
      z-index: 5;
      padding: 16px;
      position: sticky;
      bottom: 0;
      background-color: ${({ theme }) => theme.blackColor};

      button {
        font-size: 20px
      }
    }
  }
`;
